/* - 2025 - expre343  ,-.----.
            flospeed  \    /  \   __  ,-.
           ,--,  ,--, |   :    |,' ,'/ /|
   ,---.   |'. \/ .`| |   | .\ :'  | |' | ,---.
  /     \  '  \/  / ; .   : |: ||  |   ,'/     \
 /    /  |  \  \.' /  |   |  \ :'  :  / /    /  |
.    ' / |   \  ;  ;  |   : .  ||  | ' .    ' / |
'   ;   /|  / \  \  \ :     |`-';  : | '   ;   /|
'   |  / |./__;   ;  \:   : :   |  , ; '   |  / |
|   :    ||   :/\  \ ;|   | :    ---'  |   :    |
 \   \  / `---'  `--` `---'.|           \   \  /
  `----'                `---`            `----'
/////////////////////////////////////////// */

const env = 'public';
export var config = {};
let c3rtio_2026 = 'https://api.c3rt.io/api/geko/';
let apiRoot2026 = 'https://feed.gekogold.com/api_2026/';
let apiRoot2025 = 'https://feed.gekogold.com/api_2025/';


// la stessa struttura per public e local
const defaults = {
  lang: 'ita',
  app: {
    version: '@GEKOGOLD 1.0',
    foot:    'feed service'
  },
  constants : {
    ounce : 31.1034768,
  }
};

switch (env) {
  default:
  case 'public':
    config = {
      ...defaults,
      api: {
        feed: apiRoot2025 + 'FeedApiInterface.php',
        prod: apiRoot2026 + 'WalletFeedApiInterface.php',
        auth: c3rtio_2026 + 'AuthClientApiInterface.php'
      }
    };
    break;

  case 'local':
    config = {
      ...defaults,
      api: {
      }
    };
    break;
}
